
import {
  Home,
  Users,
  Bus,
  Calendar,
  Settings,
  BarChart3,
  Bell,
  Wrench,
  UserCog,
  Shield,
  UserCheck,
  CreditCard,
  HelpCircle,
  Building2,
  Wallet,
  ScanFace,
  User,
  CalendarClock,
  GraduationCap,
  Package,
  Megaphone,
  BookOpen,
} from "lucide-react"

/**
 * Menu Categories Configuration
 * Groups related menu items into collapsible categories
 * Icons are component references, not JSX elements
 */
export const MENU_CATEGORIES = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: Home,
    alwaysExpanded: true,
    items: [
      {
        id: "dashboard",
        label: "Dashboard",
        icon: Home,
        path: "/dashboard/dashboard",
      }
    ]
  },
  {
    id: 'student-management',
    label: 'Student Management',
    icon: Users,
    items: [
      {
        id: "students",
        label: "Students",
        icon: Users,
        path: "/dashboard/students",
      },
    ]
  },
   {
    id: 'attendance-management',
    label: 'Attendance Management',
    icon: UserCog,
    items: [
      {
        id: "teacher-attendance",
        label: " Attendance",
        icon: Users,
        path: "/dashboard/teacher-attendance",
      },
      {
        id: "shift-assignment",
        label: "Shift Assignment",
        icon: CalendarClock,
        path: "/dashboard/shift-assignment",
      },
      {
        id: "biometric-integration",
        label: "Biometric Integration",
        icon: ScanFace,
        path: "/dashboard/biometric-integration",
      },
      {
        id: "registration-faces",
        label: "Registration Faces",
        icon: ScanFace,
        path: "/dashboard/registration-faces",
      },
    ]
  },
  {
    id: 'class-management',
    label: 'Class Management',
    icon: Building2,
    items: [
      {
        id: "classroom-mapping",
        label: "ClassRoom Mapping",
        icon: UserCog,
        path: "/dashboard/classroom-mapping",
      },
      {
        id: "class-transition",
        label: "Class Transition",
        icon: Users,
        path: "/dashboard/class-transition",
      },
    ]
  },
  {
    id: 'inventory-assets',
    label: 'Inventory & Assets',
    icon: Package,
    items: [
      {
        id: "inventory",
        label: "Inventory",
        icon: Wrench,
        path: "/dashboard/inventory",
      },
      {
        id: "inventory-analytics",
        label: "Analytics Dashboard",
        icon: BarChart3,
        path: "/dashboard/inventory/analytics",
      },
      {
        id: "customer-ledger",
        label: "Customer Ledger",
        icon: BookOpen,
        path: "/dashboard/customer-ledger",
      },
      {
        id: "assets",
        label: "Assets",
        icon: Wrench,
        path: "/dashboard/assets",
      },
      {
        id: "vendor",
        label: "Vendor",
        icon: Wrench,
        path: "/dashboard/vendor",
      },
    ]
  },
  {
    id: 'staff-management',
    label: 'Staff Management',
    icon: UserCog,
    items: [
      {
        id: "teachers",
        label: "Teachers",
        icon: Users,
        path: "/dashboard/teachers",
      },
      {
        id: "staff",
        label: "Staff",
        icon: UserCog,
        path: "/dashboard/staff",
      }
    ]
  },
  {
    id: 'payments',
    label: 'Payments',
    icon: CreditCard,
    items: [
      {
        id: "billing",
        label: "Billing",
        icon: CreditCard,
        path: "/dashboard/billing",
      }
    ]
  },
  {
    id: 'academic',
    label: 'Academic',
    icon: GraduationCap,
    items: [
      {
        id: "holiday",
        label: "Holiday",
        icon: Calendar,
        path: "/dashboard/holiday",
      },
    ]
  },
  {
    id: 'transportation',
    label: 'Transportation',
    icon: Bus,
    items: [
      {
        id: "bus-routes",
        label: "Bus Routes",
        icon: Bus,
        path: "/dashboard/bus-routes",
      },
    ]
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: Wallet,
    items: [
      {
        id: "fee-management",
        label: "Fee Management",
        icon: BarChart3,
        path: "/dashboard/fee-management",
      },
      {
        id: "payroll",
        label: "Payroll",
        icon: Wallet,
        path: "/dashboard/payroll",
      },
    ]
  },
  {
    id: 'communication',
    label: 'Communication',
    icon: Megaphone,
    items: [
      {
        id: "announcements",
        label: "Announcements",
        icon: Bell,
        path: "/dashboard/announcements",
      },
      {
        id: "alert",
        label: "Alert Management",
        icon: Shield,
        path: "/dashboard/alert",
      },
    ]
  },
  {
    id: 'settings-system',
    label: 'Settings & System',
    icon: Settings,
    items: [
      {
        id: "settings",
        label: "Settings",
        icon: Settings,
        path: "/dashboard/settings/",
      },
      {
        id: "faq",
        label: "FAQ",
        icon: HelpCircle,
        path: "/dashboard/faq",
      }
    ]
  },
  {
    id: 'my-profile',
    label: 'My Profile',
    icon: User,
    alwaysExpanded: true,
    staffOnly: true,
    items: [
      {
        id: "profile",
        label: "My Profile",
        icon: User,
        path: "/dashboard/profile",
      },
      {
        id: "staff-leave",
        label: "Leave Management",
        icon: CalendarClock,
        path: "/dashboard/staff-leave",
      },
      {
        id: "staff-attendance",
        label: "My Attendance",
        icon: UserCheck,
        path: "/dashboard/staff-attendance",
      },
    ]
  },
]
